const Colors = [
  "#DB4832",
  "#434157",
  "#3B8244",
  "#459ED9",
  "#F2BD44"
];

export { Colors }